import { useState } from "react";
import { useAdminCategoriesContext } from "../../../hooks/useAdminCategoriesContext";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { apiFetch } from "../../../utils/api";
import { SUPPORTED_LANGUAGES, normalizeTranslation } from "../../../utils/translationUtils";
import Button from "../../Button/Button";

const CategoryForm = ({ category, onSuccess }) => {
  const { dispatch } = useAdminCategoriesContext();
  const { user } = useAuthContext();
  const [titles, setTitles] = useState(() => normalizeTranslation(category?.translations));
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const isEditing = Boolean(category);

  const handleTitleChange = (lang, value) => {
    setTitles((prev) => ({ ...prev, [lang]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      setError("Request not authenticated");
      return;
    }

    setLoading(true);
    setError(null);

    const response = await apiFetch(
      isEditing ? `/api/admin/categories/${category._id}` : "/api/admin/categories",
      {
        method: isEditing ? "PATCH" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({ translations: titles }),
      }
    );
    const json = await response.json();

    setLoading(false);

    if (!response.ok) {
      setError(json.error);
      return;
    }

    if (isEditing) {
      dispatch({ type: "UPDATE_CATEGORY", payload: json });
    } else {
      dispatch({ type: "CREATE_CATEGORY", payload: json });
      setTitles(normalizeTranslation());
    }
    onSuccess?.();
  };

  const submitLabel = isEditing ? "Save Category" : "Create Category";
  const loadingLabel = isEditing ? "Saving..." : "Creating...";

  return (
    <form onSubmit={handleSubmit}>
      {SUPPORTED_LANGUAGES.map((lang) => (
        <div key={lang}>
          <label htmlFor={`title-${lang}`}>Title ({lang.toUpperCase()})</label>
          <input
            id={`title-${lang}`}
            type="text"
            value={titles[lang]}
            onChange={(e) => handleTitleChange(lang, e.target.value)}
            required
          />
        </div>
      ))}

      <Button variant="primary" type="submit" disabled={loading}>
        {loading ? loadingLabel : submitLabel}
      </Button>

      {error && <div className="form-message error">{error}</div>}
    </form>
  );
};

export default CategoryForm;
